export default __webpack_public_path__ + "2d25fd17740c091f41f441e86683ea62.svg";